
import externalConfiguration from '../external-configuration';
import { avoidCache } from './utils';
import playerToState from './player-to-state';
import { legacyLoadVideo } from './legacy-to-state';
import playlistToState from '../helpers/playlist-to-state';

function chatToState( iframeId) {
  return fetch( avoidCache( externalConfiguration.chatBackEndDomain + '/iframe/' + iframeId)).then( response => response.json()).then( iframeData => {
    const [ id1, id2 ] = iframeData.content.split( '/');
    let promiseOfSettings;
    if( id1 === 'playlist') {
      promiseOfSettings = playlistToState( id2);
    } else {
      promiseOfSettings = playerToState( id1, iframeData.vdm_user)    // TODO: En el futuro toda la informacion del tipo/s de contenido/s vendra en iframeData
      .then( settings => {                                            //  permitiendo desacoplar estas llamadas y hacerlas en paralelo.
        if( settings.visualizerOptions.srcType === 'vod') {
          settings = legacyLoadVideo( iframeData.vdm_user, id2.toLowerCase(), Promise.resolve( settings));
        }
        return settings;
      });
    }
    return promiseOfSettings.then( settings => {
      let showingChat = true;
      const onResize = ( state) => {
        const chatPlayerSize = showingChat ? externalConfiguration.chatSettings.playerSize : 1.0;
        state.customProps.width = window.innerWidth * chatPlayerSize;
        state.customProps.height = window.innerHeight;
        return state;
      }
      const onShowHide = ( state) => {
        showingChat = !showingChat;
        const chatPlayerSize = showingChat ? externalConfiguration.chatSettings.playerSize : 1.0;
        state.customProps.width = window.innerWidth * chatPlayerSize;
        state.chatSettings.showingChat = showingChat;
        return state;
      }
      const extraButtons = [{ imgSrc: '/vdmplayer/resources/Chat_ShowHide.svg', text: 'Mostrar / Ocultar Chat', handler: onShowHide, id: 'M/OChat'}];
      settings.visualizerType = 'Chat';
      settings.chatSettings = { iframeId, hasRegister: iframeData.allowRegister, showingChat};
      settings.customProps = Object.assign( {}, settings.customProps, { width: window.innerWidth * externalConfiguration.chatSettings.playerSize});
      settings.visualizerOptions = Object.assign( {}, settings.visualizerOptions, { onResize});
      settings.basePlayerOptions = Object.assign( {}, settings.basePlayerOptions, { extraButtons});
      return settings;
    });
  });
}

export default chatToState;



// WEBPACK FOOTER //
// ./src/helpers/chat-to-state.js